import { render, staticRenderFns } from "./CostCentreTable.vue?vue&type=template&id=18a34f2d&"
import script from "./CostCentreTable.vue?vue&type=script&lang=js&"
export * from "./CostCentreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports